import React from 'react';

import alertIcon from '~/assets/images/error_outline.svg';
import { Container, AlertContainer, ButtonContainer, Button } from './styles';
import api from '~/services/api';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

function InativeModal({ close, employeeData }) {
  const history = useHistory();
  const inactiveEmployee = async () => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      active: false,
    };
    await api
      .patch(
        `residential/store/v1/users/${employeeData.ownerid}/employees/${employeeData.userId}`,
        body,
        parameters,
      )
      .then(res => {
        if (res.status) {
          if (res.status === 204) {
            toast.success('Funcionario inativado com sucesso!');
            document.location.reload(true);
          }
        }
        close();
      })
      .catch(err => {
        toast.error(err.response.data.message);
      });
  };

  return (
    <Container>
      <h1>Atenção!</h1>
      <AlertContainer>
        <img src={alertIcon} alt="alert icon" />
        <span>
          Você tem certeza que deseja inativar o usuário{' '}
          <b>{employeeData.contacts[0].name}</b>?
        </span>
      </AlertContainer>
      <ButtonContainer>
        <Button onClick={close}>Cancelar</Button>
        <Button confirm onClick={inactiveEmployee}>
          Confirmar
        </Button>
      </ButtonContainer>
    </Container>
  );
}

export default InativeModal;
